"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toArray = require("../methods/$to-array/to-array");

var _map = require("../methods/$map/map");

function toAnySubseq({
  any,
  subseq
}, value) {
  const values = any ? (0, _toArray.toArray)(value) : [value];
  const subseqs = (0, _toArray.toArray)((0, _map.map)(values, value => subseq ? typeof value === 'string' ? value : (0, _toArray.toArray)(value) : [value]));
  return subseqs;
}

var _default = toAnySubseq;
exports.default = _default;
module.exports = exports["default"];